function cssHeaderHeight() {
  document.documentElement.style.setProperty(
    "--pg-header-height",
    document.querySelector("header .header_menu").clientHeight + "px"
  );
}
cssHeaderHeight();
window.addEventListener("resize", cssHeaderHeight);

function citeHeight(){
  let citeHeight = 0;
  document.querySelectorAll(".slider-cite .slider-item-cite").forEach(function(e){
    let totalHeight = 0;

    for (const child of e.children) {
      if(child.tagName.toLowerCase() !== 'img') totalHeight += child.clientHeight;
    }

    if(totalHeight > citeHeight) citeHeight = totalHeight;
  });
  document.documentElement.style.setProperty(
    "--pg-cite-height",
    citeHeight + "px"
  );
}

setTimeout(citeHeight,800);
window.addEventListener("resize", citeHeight);